import type { StepType } from "@reactour/tour";
import TourStepContent from "../../wrapper";
import { text } from "@quickpoint.me/shared";

const whatsNext: StepType[] = [
	{
		selector: ".tour",
		content: () => (
			<TourStepContent
				description={() => (
					<span>
						{text.tourSteps.teacherBasics}
					</span>
				)}
			/>
		),
	},
	{
		selector: "window",
		content: () => (
			<TourStepContent
				description={() => (
					<span>
						{text.tourSteps.teacherExperiment}
						<br />
						<br />
						{text.tourSteps.teacherHaveFun}
					</span>
				)}
			/>
		),
		position: "center",
	},
];

export default whatsNext;
